// 未保存検知のための内容署名。
//
// dirty フラグは立て忘れが起きるので、内容ハッシュの比較で判定する
// (参照プロジェクト backupSignature.ts と同じ方針)。
// - meta.updatedAt と activeLayerIds は署名に含めない (選択しただけで dirty にしない)
// - ピクセルの変更は Document.pixelGeneration が +1 されるので署名に反映される

import type { Document } from '@/types/document'

/** cyrb53: 依存なしの 53bit ハッシュ */
export function hash53(str: string, seed = 0): number {
  let h1 = 0xdeadbeef ^ seed
  let h2 = 0x41c6ce57 ^ seed
  for (let i = 0; i < str.length; i++) {
    const ch = str.charCodeAt(i)
    h1 = Math.imul(h1 ^ ch, 2654435761)
    h2 = Math.imul(h2 ^ ch, 1597334677)
  }
  h1 = Math.imul(h1 ^ (h1 >>> 16), 2246822507)
  h1 ^= Math.imul(h2 ^ (h2 >>> 13), 3266489909)
  h2 = Math.imul(h2 ^ (h2 >>> 16), 2246822507)
  h2 ^= Math.imul(h1 ^ (h1 >>> 13), 3266489909)
  return 4294967296 * (2097151 & h2) + (h1 >>> 0)
}

export function contentSignature(doc: Document): string {
  const normalized: Document = {
    ...doc,
    meta: { ...doc.meta, updatedAt: 0 },
    activeLayerIds: []
  }
  return hash53(JSON.stringify(normalized)).toString(36)
}

/** 何も作っていない状態 (レイヤーなし・ピクセル変更なし) は警告の対象にしない */
export function isEmptyDocument(doc: Document): boolean {
  return doc.rootChildren.length === 0 && doc.pixelGeneration === 0
}
